module.exports = __webpack_public_path__ + "img/fuzhu.d3a3903f.png";